/**
 * Что показывать в профиле в поле «Автосалон».
 *
 * Раньше здесь стояла строка «Kia DOSCAR: ул. Елебекова, 10/1», одинаковая для
 * всех: руководитель из Астаны видел алматинский адрес. Берём центры самого
 * пользователя — те же, что определяют его доступ к сделкам.
 */
export const dealerCentresText = (user) => {
  const centres = user?.dealerCenters || [];
  if (centres.length === 0) return '—';
  return centres
    .map((dc) => {
      const name = (dc?.name || '').trim();
      const address = (dc?.address || '').replace(/\s+/g, ' ').trim();
      return address ? `${name}: ${address}` : name;
    })
    .filter(Boolean)
    .join('; ');
};

/** Название роли; пока бэкенд не отдаёт его — пусто, а не «undefined». */
export const roleText = (user) => user?.roleTitle || user?.role?.title || '—';
